import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=36f3e384&scoped=true"
import script from "./TagList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagList.vue?vue&type=style&index=0&id=36f3e384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3e384",
  null
  
)

export default component.exports